
import axios from 'axios';

// Types
import type { TAutomatedEmailDomainStatus } from '~/modules/opportunities/automated-email/types';
import type { TAutomatedEmailDomainState } from '~/modules/opportunities/automated-email/show/types';

// Config
import { AUTOMATED_EMAIL_DOMAIN_ACTIVE_STATE } from '~/modules/opportunities/automated-email/show/config';

const DOMAIN_GATE_BLOCKING_HTTP_STATUSES: ReadonlySet<number> = new Set<number>([403, 404]);

export const isAutomatedEmailDomainActive = (
  state: TAutomatedEmailDomainState | string
): boolean => state === AUTOMATED_EMAIL_DOMAIN_ACTIVE_STATE;

/** True when the user must see the domain gate message instead of the tabs. */
export const shouldBlockAutomatedEmailForDomainStatus = (
  status: TAutomatedEmailDomainStatus
): boolean => !isAutomatedEmailDomainActive(status.state);

/** True when `domains/status` failed because the domain is missing or the user cannot access it. */
export const shouldBlockAutomatedEmailForDomainStatusError = (error: unknown): boolean => {
  if (!axios.isAxiosError(error)) {
    return false;
  }

  const httpStatus: number | undefined = error.response?.status;

  if (httpStatus === undefined) {
    return false;
  }

  return DOMAIN_GATE_BLOCKING_HTTP_STATUSES.has(httpStatus);
};
